// Global variables
const saveBtn = document.querySelector('[data-name="save-curr-and-lang-form"]');
const geolocItems = document.querySelectorAll('[data-name="geoloc-item"]');
const geoLocLocSpan = document.querySelector('[data-name="location-span"]');
const geoLocLangSpan = document.querySelector('[data-name="lang-span"]');
const geolocMobileLangBtn = document.querySelector('[data-name="mobile-lang-btn"]');
const geolocMobileLangBtnAb = document.querySelector('[data-name="mobile-lang-btn-ab"]');
const geolocLangBtnSwitchers = document.querySelectorAll('[data-name="lang-switch-info"]');

// Lang selector func
const prevFieldLang = document.querySelector('[data-name="preview-lang-field"]');
const inputsLang = document.querySelector('[data-name="inputs-lang"]');
const langSelectors = document.querySelectorAll('[data-name="lang-popup-selector"]');

function openGeolocDrawerFromSidebar() {
  const drawerOpen = document.querySelector("#geoloc-drawer");

  // Close whichever sidebar is currently open (original or AB)
  const originalSidebar = document.querySelector("#sidebar-menu");
  const abSidebar = document.querySelector("#sidebar-menu-ab");

  if (originalSidebar && originalSidebar.hasAttribute('open')) {
    originalSidebar.hide();
  }
  if (abSidebar && abSidebar.hasAttribute('open')) {
    abSidebar.hide();
  }

  drawerOpen.show(); // Open the drawer
}

// Check if cookies exist and show or hide welcome popup after delay
function checkCookies() {
  function getGeolocalizerIsoCode() {
    const countryLangHandle = navigator.language.slice(0, 2) || navigator.userLanguage.slice(0, 2);
    if (countryLangHandle == "de" || document.documentElement.lang == "de") {
      document.querySelector('[data-name="welcome-cookie-heading"]').textContent = "Wir verwenden Cookies";
      document.querySelector('[data-name="welcome-cookie-msg"]').innerHTML = `
          Wir verwenden notwendige Cookies, damit unsere Website ordnungsgemäß funktioniert. Wir setzen optionale Cookies ein, um dir beim Surfen auf unserer Website ein maßgeschneidertes Design zu bieten und Informationen anzuzeigen, die auf deinen Standort abgestimmt sind. Wir geben auch Informationen über deine Nutzung unserer Website an unsere Partner für soziale Medien, Werbung und Analysen weiter. Indem du auf "Alle akzeptieren" klickst, stimmst du unserer Verwendung von Cookies zu. Ausführlichere Informationen findest du in unserer <a href="/policies/privacy-policy">Datenschutzrichtlinie</a>.`;
      document.querySelector('[data-name="cookie-settings-btn"]').textContent = "Einstellungen anpassen";
      document.querySelector('[data-name="cookie-necessary-btn"]').textContent = "Speichern";
      document.querySelectorAll('[data-name="cookie-accept-btn"]').forEach((btn) => {
        btn.textContent = "Alle zulassen";
      });
      document.querySelector('[data-name="privacy-cookie-heading"]').textContent = "Wir schützen deine Privatsphäre";
      document.querySelector('[data-name="privacy-cookie-msg"]').innerHTML = `
          Wir verwenden Cookies, um dein Surferlebnis zu verbessern, personalisierte Werbung oder Inhalte zu präsentieren und unseren Datenverkehr zu analysieren. Wenn du auf "Alle akzeptieren" klickst, stimmst du unserer Verwendung von Cookies zu. <a href="/policies/privacy-policy">Datenschutzrichtlinie</a>.`;

      document.querySelector('[data-name="necessary-cookie-heading"]').textContent = "Notwendige Cookies";
      document.querySelector('[data-name="necessary-cookie-msg"]').textContent =
        "Sind für das ordnungsgemäße Funktionieren der Website oder der Funktionen, die du nutzen möchtest, unbedingt erforderlich, da wir ohne sie viele der von uns angebotenen Dienste nicht anbieten könnten.";

      document.querySelector('[data-name="functional-cookie-heading"]').textContent = "Funktionale Cookies";
      document.querySelector('[data-name="functional-cookie-msg"]').textContent =
        "Sind wichtig für den Betrieb der Website, um die Funktionalität der Websites zu bereichern. Ohne sie wird die Website ordnungsgemäß funktionieren, wird aber nicht auf die Präferenzen des Nutzers zugeschnitten sein. Dazu gehören: Funktionale Cookies; Business-Cookies; Cookies für die Konfiguration der Website; Cookies für Sicherheit und Zuverlässigkeit; Authentifizierungs-Cookies; Cookies für den Zugriff auf den Standort.";

      document.querySelector('[data-name="analytics-cookie-heading"]').textContent = "Analyse-Cookies";
      document.querySelector('[data-name="analytics-cookie-msg"]').textContent =
        "Ermöglichen es dem Eigentümer der Website, die Präferenzen seiner Nutzer besser zu verstehen und durch Analyse Produkte und Dienstleistungen zu verbessern und zu entwickeln. Einschließlich: Session Research Cookies; Cookies zur Untersuchung der auf der Website stattfindenden Prozesse; Analyse-, Forschungs- und Auditing-Cookies.";

      document.querySelector('[data-name="marketing-cookie-heading"]').textContent = "Marketing-Cookies";
      document.querySelector('[data-name="marketing-cookie-msg"]').textContent =
        "Ermöglichen die Anzeige von Werbung, die für die Nutzer interessanter und gleichzeitig für die Herausgeber und Werbetreibenden wertvoller ist. Einschließlich: Werbe-Cookies";
    } else if (countryLangHandle == "pl" || document.documentElement.lang == "pl") {

      document.querySelector('[data-name="welcome-cookie-heading"]').textContent = "Używamy plików cookies";
      document.querySelector('[data-name="welcome-cookie-msg"]').innerHTML = `
          Aby nasza strona działała poprawnie używamy niezbędnych plików cookies. Opcjonalne pliki cookies ustawiamy, aby zapewnić Ci optymalne i dostosowane do potrzeb przeglądanie naszej witryny i aby wyświetlać informacje odpowiednie dla Twojej lokalizacji. Informacje o korzystaniu z naszej witryny udostępniamy również naszym partnerom w zakresie mediów społecznościowych, reklam i analiz. Klikając „Akceptuj wszystko” wyrażasz zgodę na używanie przez nas plików cookies. Aby uzyskać bardziej szczegółowe informacje, sprawdź naszą <a href="/policies/privacy-policy">Politykę prywatności</a>.`;
      document.querySelector('[data-name="cookie-settings-btn"]').textContent = "Dostosuj ustawienia";
      document.querySelector('[data-name="cookie-necessary-btn"]').textContent = "Zapisz moje ustawienia";
      document.querySelectorAll('[data-name="cookie-accept-btn"]').forEach((btn) => {
        btn.textContent = "Akceptuj wszystko";
      });
      document.querySelector('[data-name="privacy-cookie-heading"]').textContent = "Szanujemy Twoją prywatność";
      document.querySelector('[data-name="privacy-cookie-msg"]').innerHTML = `
          Używamy plików cookies, aby poprawić Twój komfort przeglądania, wyświetlać spersonalizowane reklamy lub treści oraz analizować nasz ruch. Klikając „Akceptuj wszystko” wyrażasz zgodę na używanie przez nas plików cookies. <a href="/policies/privacy-policy">Polityka Cookie</a>.`;

      document.querySelector('[data-name="necessary-cookie-heading"]').textContent = "Niezbędne pliki cookies";
      document.querySelector('[data-name="necessary-cookie-msg"]').textContent =
        "Są absolutnie niezbędne do prawidłowego funkcjonowania serwisu lub funkcjonalności, z których chcesz korzystać, gdyż bez nich nie moglibyśmy świadczyć wielu oferowanych przez nas usług.";

      document.querySelector('[data-name="functional-cookie-heading"]').textContent = "Funkcjonalne pliki cookies";
      document.querySelector('[data-name="functional-cookie-msg"]').textContent =
        "Są ważne dla działania serwisu, aby wzbogacić funkcjonalność serwisów. Bez nich serwis będzie działał poprawnie, ale nie będzie dostosowany do preferencji użytkownika. Zawierają: pliki cookies o charakterze funkcjonalnym; biznesowe pliki cookies; pliki cookies służące do konfiguracji serwisu; pliki cookies dla bezpieczeństwa i niezawodności; pliki cookies uwierzytelniające; pliki cookies uzyskujące dostęp do lokalizacji.";

      document.querySelector('[data-name="analytics-cookie-heading"]').textContent = "Analityczne pliki cookies";
      document.querySelector('[data-name="analytics-cookie-msg"]').textContent =
        "Pozwalają właścicielowi serwisu lepiej poznać preferencje jego użytkowników i poprzez analizę ulepszać i rozwijać produkty i usługi. Zawierają: pliki cookies służące badaniu sesji; pliki cookies służące badaniu procesów zachodzących w serwisie; pliki cookies analityczne, badawcze i audytowe.";

      document.querySelector('[data-name="marketing-cookie-heading"]').textContent = "Marketingowe pliki cookies";
      document.querySelector('[data-name="marketing-cookie-msg"]').textContent =
        "Umożliwiają wyświetlanie reklam, które są interesujące dla użytkowników, a jednocześnie bardziej wartościowe dla wydawców i reklamodawców. Zawierają: pliki cookies służące do wyświetlania reklam.";
    } else if (countryLangHandle == "fr" || document.documentElement.lang == "fr") {

      document.querySelector('[data-name="welcome-cookie-heading"]').textContent = "Nous utilisons des cookies";
      document.querySelector('[data-name="welcome-cookie-msg"]').innerHTML = `
          Nous utilisons des cookies nécessaires permettant à notre site web de fonctionner correctement. Nous définissons des cookies facultatifs pour vous offrir une expérience de conception sur mesure lorsque vous naviguez sur notre site web et afficher des informations appropriées à votre localisation. Nous partageons également des informations sur votre utilisation de notre site avec nos partenaires de médias sociaux, de publicité et d'analyse. En cliquant sur « Tout accepter », vous consentez à notre utlisation des cookies. Pour des informations plus détaillées, consultez notre <a href="/policies/privacy-policy">Politique de confidentialité</a>.`;
      document.querySelector('[data-name="cookie-settings-btn"]').textContent = "Personnaliser les paramètres";
      document.querySelector('[data-name="cookie-necessary-btn"]').textContent = "Enregistrer mes préférences";
      document.querySelectorAll('[data-name="cookie-accept-btn"]').forEach((btn) => {
        btn.textContent = "Tout accepter";
      });
      document.querySelector('[data-name="privacy-cookie-heading"]').textContent = "Nous respectons votre vie privée";
      document.querySelector('[data-name="privacy-cookie-msg"]').innerHTML = `
          Nous utilisons des cookies pour améliorer votre expérience de navigation, diffuser des publicités ou des contenus personnalisés et analyser notre trafic. En cliquant sur « Tout accepter », vous consentez à notre utilisation des cookies. <a href="/policies/privacy-policy">Politique en matière de cookies</a>.`;

      document.querySelector('[data-name="necessary-cookie-heading"]').textContent = "Cookies nécessaires";
      document.querySelector('[data-name="necessary-cookie-msg"]').textContent =
        "Sont absolument nécessaires au bon fonctionnement du site web ou de la fonctionnalité que vous souhaitez utiliser, car sans eux, nous ne pourrions pas fournir un grand nombre des services que nous proposons.";

      document.querySelector('[data-name="functional-cookie-heading"]').textContent = "Cookies fonctionnels";
      document.querySelector('[data-name="functional-cookie-msg"]').textContent =
        "Sont importants pour le fonctionnement du site web pour améliorer la fonctionnalité des sites web, sans lesquels, le site web fonctionnera correctement, mais ne sera pas adapté aux préférences de l'utilisateur. Notamment : Cookies de nature fonctionnelle ; Cookies de nature commerciale ; Cookies de configuration du site web ; Cookies de sécurité et de fiabilité ; Cookies d'authentification ; Cookies d'accès à la localisation.";

      document.querySelector('[data-name="analytics-cookie-heading"]').textContent = "Cookies d'analyse";
      document.querySelector('[data-name="analytics-cookie-msg"]').textContent =
        "Permettent au propriétaire du site web de mieux comprendre les préférences de ses utilisateurs et, grâce à l'analyse, d'améliorer et de développer des produits et services. Notamment : Cookies de recherche de session ; Cookies d'étude des processus se déroulant sur le site ; Cookies d'analyse de recherche et d'audit d'audience.";

      document.querySelector('[data-name="marketing-cookie-heading"]').textContent = "Cookies de marketing";
      document.querySelector('[data-name="marketing-cookie-msg"]').textContent =
        "Permettent d'afficher des publicités plus intéressantes pour les utilisateurs et en même temps plus valorisantes pour les éditeurs et les annonceurs. Y compris : les cookies d'adserving";
    }
  }
  if (document.cookie.indexOf("popup-module") >= 0) {
    getGeolocalizerIsoCode();
  }

  // Set cookies to visited - hide welcome popup till cookies cleared (one year)
  setCookie("popup-module", "visited", 360);
}
checkCookies();

if (geolocMobileLangBtn) {
  geolocMobileLangBtn.addEventListener("click", openGeolocDrawerFromSidebar);
  function changeCurrentLangAndCurrInSidebar() {
    geolocLangBtnSwitchers.forEach((btn) => {
      if (document.URL.indexOf("/de") > -1) {
        btn.innerHTML = "Deutch";
      } else if (document.URL.indexOf("/pl") > -1) {
        btn.innerHTML = "Polski";
      } else if (document.URL.indexOf("/fr") > -1) {
        btn.innerHTML = "Français";
      } else {
        btn.innerHTML = "English";
      }
    });
  }
  changeCurrentLangAndCurrInSidebar();
}

// ! AB logic -> start
if (geolocMobileLangBtnAb) {
  geolocMobileLangBtnAb.addEventListener("click", openGeolocDrawerFromSidebar);
  function changeCurrentLangAndCurrInSidebar() {
    geolocLangBtnSwitchers.forEach((btn) => {
      if (document.URL.indexOf("/de") > -1) {
        btn.innerHTML = "Deutch";
      } else if (document.URL.indexOf("/pl") > -1) {
        btn.innerHTML = "Polski";
      } else if (document.URL.indexOf("/fr") > -1) {
        btn.innerHTML = "Français";
      } else {
        btn.innerHTML = "English";
      }
    });
  }
  changeCurrentLangAndCurrInSidebar();
}
// ! AB logic -> end

// Display current lang in the preview input
function loadLangPreviewNameOnLoad() {
  if (document.documentElement.lang == "de") {
    prevFieldLang.innerHTML = `
    <div class="country-wrapper-content">
    <div class="icon-wrap">
    <svg data-name="mega-icons" width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11.5" cy="11" r="10" stroke="#393939" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.4191 7.37549H13.4191V10.9944M17.4191 14.6133H13.4191V10.9944M13.4191 10.9944H17.4191M5.58105 7.37549V10.9944V14.6133H7.39058C8.62075 14.7161 10.8469 14.1362 10.8469 10.9944C10.8082 9.78808 10.2501 7.37549 7.39058 7.37549H5.58105Z" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </div><span data-value="de">Deutsch</span></div>
    `;
  } else if (document.documentElement.lang == "pl") {
    prevFieldLang.innerHTML = `
    <div class="country-wrapper-content">
    <div class="icon-wrap">
    <svg data-name="mega-icons" width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11.5" cy="11" r="10" stroke="#393939" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.3701 7.11328V14.8869H16.4109M7.15674 14.8869V11.1685M7.15674 11.1685H8.47842C10.8324 11.1685 10.8415 9.88056 10.8324 9.1409C10.8324 7.5188 9.26308 7.11328 8.47842 7.11328H7.15674V9.1409V11.1685Z" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </div><span data-value="pl">Polski</span></div>
    `;
  } else if (document.documentElement.lang == "fr") {
    prevFieldLang.innerHTML = `
    <div class="country-wrapper-content">
    <div class="icon-wrap">
    <svg data-name="mega-icons" width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11.5" cy="11" r="10" stroke="#393939" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.45435 14.9364V10.7271M9.64544 10.7271H6.45435M6.45435 10.7271V7.06774H9.76076M12.5093 14.9364V11.2266M13.8932 11.2266H12.5093M13.8932 11.2266C15.7691 11.2266 16.2253 9.84028 16.2188 9.14709C16.2124 8.41311 15.7383 6.96966 13.8932 7.06774L12.5093 7.06753V9.14709V11.2266M13.8932 11.2266L16.5456 14.9364" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </div><span data-value="fr">Français</span></div>
    `;
  } else {
    prevFieldLang.innerHTML = `
    <div class="country-wrapper-content">
    <div class="icon-wrap">
    <svg data-name="mega-icons" fill="none" height="23" viewbox="0 0 23 23" width="23" xmlns="http://www.w3.org/2000/svg"><circle cx="11.5322" cy="11.4246" r="10" stroke="#393939" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.74693 7.48267H5.74023V11.1016M9.74693 14.7204H5.74023V11.1016M5.74023 11.1016H9.74693M12.0089 15.3667V7.48267L17.3251 15.3667V7.48267" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </div><span data-value="en">English</span></div>
    `;
  }
}
loadLangPreviewNameOnLoad();

// Change current lang in the preview input
function loadLangPreviewNameOnChange(e) {
  prevFieldLang.innerHTML = e.target.nextElementSibling.innerHTML;
}
inputsLang.addEventListener("change", loadLangPreviewNameOnChange);

// Add cookies when lang is selected and save it for later verification
langSelectors.forEach((selector) => {
  selector.addEventListener("change", function (e) {
    const selected = e.target.value;
    setCookie("selected-lang", selected, 360);
    setCookie("popup-lang", "load", 360);
    langSelectors.forEach((selector) => selector.nextElementSibling.classList.remove("selected-lang"));
    inputsLang.removeAttribute("open");
    if (selector.id == e.target.id) {
      e.target.nextElementSibling.classList.add("selected-lang");
    }
  });
});

// Country selector variables
const prevFieldCountry = document.querySelector('[data-name="preview-country-field"]');
const inputsCountry = document.querySelector('[data-name="inputs-countries"]');
const countrySelectors = document.querySelectorAll('[data-name="country-popup-selector"]');

// Add cookies when country is selected and save it for later verification
countrySelectors.forEach((selector) => {
  selector.addEventListener("change", function (e) {
    countrySelectors.forEach((selector) => selector.nextElementSibling.classList.remove("selected-country"));
    inputsCountry.removeAttribute("open");
    if (selector.id == e.target.id) {
      e.target.nextElementSibling.classList.add("selected-country");
      setCookie("selected-country", e.target.id, 360);
    }
  });
});

// Display current country in the preview input
function loadCountryPreviewName(e) {
  prevFieldCountry.innerHTML = e.target.nextElementSibling.innerHTML;
}
inputsCountry.addEventListener("change", loadCountryPreviewName);

// Check selected lang and hide it form the list (add selected class)
langSelectors.forEach((selector) => {
  if (selector.value == prevFieldLang.querySelector(".country-wrapper-content").lastChild.getAttribute("data-value")) {
    selector.nextElementSibling.classList.add("selected-lang");
  }
});

// Check selected country and hide it form the list (add selected class)
countrySelectors.forEach((selector) => {
  if (selector.value == prevFieldCountry.querySelector(".country-wrapper-content").lastElementChild.getAttribute("data-value")) {
    selector.nextElementSibling.classList.add("selected-country");
  }
});

// LANGUAGE URL AND REGEX
const langSelector = document.querySelector('[data-name="lang-popup-selector"]');
const urlAddress = window.location.href;
const regex_second = /https?:\/\/[^\/]+(\/.*)/;
const regex_first = /https?:\/\/[^\/]+/;
const regex_cleaner = /\/(de|fr|en|pl)/g;
const regex_cleaner_uk = /(uk.)/g;

const match_first = urlAddress.match(regex_first);
const match_second = urlAddress.match(regex_second);
let urlFirstPart = match_first[0];
const urlSecondPart = match_second[1];

// Check if UK in url
function urlUkCheckerAndRemover() {
  if (urlFirstPart.indexOf("uk.") > 0) {
    urlFirstPart = urlFirstPart.replace(regex_cleaner_uk, "");
    setCookie("selected-lang", "en", 360);
  }
}

if (window.location.href.indexOf("//uk.noo.ma/") > 0) {
  document.querySelector(".langitem-label").classList.add("blocked");
  setCookie("selected-lang", "en", 360);
}
// Modify URL based on user's pick and cookies
const currentLang = getCookie("selected-lang");
const onlyOneLoad = getCookie("popup-lang");

function relaodWithLangSuffix() {
  // Set lang cookies - reload or not reload
  if (onlyOneLoad === "load") {
    langSelectors.forEach((selector) => {
      if (selector.value == currentLang) {
        selector.selected = "selected";
        if (selector.value == "en") {
          setCookie("popup-lang", "stop", 360);
          Weglot.switchTo("en");
        } else if (selector.value == "de" && document.documentElement.lang != "de") {
          urlUkCheckerAndRemover();
          Weglot.switchTo("de");
          if (geolocMobileLangBtn || geolocMobileLangBtnAb) {
            geolocLangBtnSwitchers.forEach((btn) => {
              btn.innerHTML = "DE";
            });
          }
        } else if (selector.value == "pl" && document.documentElement.lang != "pl") {
          urlUkCheckerAndRemover();
          Weglot.switchTo("pl");
          if (geolocMobileLangBtn || geolocMobileLangBtnAb) {
            geolocLangBtnSwitchers.forEach((btn) => {
              btn.innerHTML = "PL";
            });
          }
        } else if (selector.value == "fr" && document.documentElement.lang != "fr") {
          urlUkCheckerAndRemover();
          Weglot.switchTo("fr");
          if (geolocMobileLangBtn || geolocMobileLangBtnAb) {
            geolocLangBtnSwitchers.forEach((btn) => {
              btn.innerHTML = "FR";
            });
          }
        } else {
          return;
        }
      }
    });
  }
}

if (document.cookie.indexOf("redirect-activator=") >= 0) {
  setTimeout(() => {
    relaodWithLangSuffix();
  }, 100);
}
relaodWithLangSuffix();

// Show/hide list when opened
geolocItems.forEach((item) => {
  item.addEventListener("click", function () {
    if (this.classList.contains("open")) {
      this.classList.remove("open");
    } else {
      geolocItems.forEach((item) => {
        item.classList.remove("open");
        document.querySelectorAll(".details-inputs").forEach((list) => {
          list.removeAttribute("open");
        });
      });
      this.classList.add("open");
    }
    if (item.classList.contains("open")) {
      this.querySelector(".details-inputs").setAttribute("open", "open");
    } else {
      this.querySelector(".details-inputs").removeAttribute("open");
    }
  });
});

document.querySelectorAll('[data-lang="lang-button"]').forEach((lang) => {
  lang.addEventListener("click", function () {
    if (document.cookie.indexOf("redirect-activator=") < 0) {
      setCookie("redirect-activator", "activate", 30);
    }
  });
});